module.exports = __webpack_public_path__ + "img/android_user.b33449ce.png";